import locationDistanceCreateComponent from './location_distance.create.component';

let locationDistanceCreateModule = angular.module('locationDistanceCreate', [])

    .component('locationDistanceCreate', locationDistanceCreateComponent)

    .name;

export default locationDistanceCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/create/index.js